import fetchServer from "../helpers/api/fetchServer";

export const getAdAccounts = async () => {
  const method = "GET";
  const urlAPI = "/api/adAccounts";
  return await fetchServer({ method, urlAPI });
};

export const getAdAccountsByAccount = async (accountId) => {
  const method = "GET";
  const urlAPI = `/api/adAccounts?account=${accountId}`;
  return await fetchServer({ method, urlAPI });
};

export const getAdAccountsByAdPlatform = async (adPlatformId) => {
  const method = "GET";
  const urlAPI = `/api/adAccounts?adPlatform=${adPlatformId}`;
  return await fetchServer({ method, urlAPI });
};

export const getAdAccountsByAdvertiser = async (advertiserId) => {
  const method = "GET";
  const urlAPI = `/api/adAccounts?advertiser=${advertiserId}`;
  return await fetchServer({ method, urlAPI });
};


export const getAdAccount = async (id) => {
  const method = "GET";
  const urlAPI = `/api/adAccounts/${id}`;
  return await fetchServer({ method, urlAPI });
};

export const updateAdAccount = async ({
  id,
  advertiserId,
  accountIds,
  isUsedForAllCountries,
  countryId,
  isUsedForUploadCreatives,
  isUsedForPostCreatives,
}) => {
  const method = "PATCH";
  const urlAPI = `/api/adAccounts/${id}`;
  const body = {
    advertiser:advertiserId,
    accounts: accountIds,
    country: countryId,
    isUsedForAllCountries,
    isUsedForUploadCreatives,
    isUsedForPostCreatives,
  };
  return await fetchServer({ method, urlAPI, body });
};
